import React from 'react';
import { cn } from '../lib/utils';
export const Logo = ({
  className
}: {
  className?: string;
}) => {
  return <div className={cn('flex items-center gap-2', className)} data-id="element-109">
      <div className="w-10 h-10 rounded-full p-[2px] bg-gradient-ring flex items-center justify-center" data-id="element-110">
        <div className="w-full h-full bg-white rounded-full flex items-center justify-center" data-id="element-111">
          <span className="font-heading italic font-bold text-lg text-brand-magenta" data-id="element-112">
            BL
          </span>
        </div>
      </div>
      <span className="font-heading font-semibold text-xl tracking-wide" data-id="element-113">
        Beauty Lab
      </span>
    </div>;
};